import { Box } from "@mui/material";
import React from "react";
import { Color } from "../constants";

const FettiCheckbox = ({ selected, width = 16 }) => {
  return (
    <Box
      sx={{
        width: width,
        height: width,
        borderRadius: "2px",
        backgroundColor: selected ? Color.primary : "#fff",
        // border: selected ? "1px solid #000" : "1.5px solid #aaa",
        border: selected ? `1.5px solid ${Color.primary}` : "1.5px solid #aaa",
      }}>
      {selected && (
        <Box
          sx={{
            position: "relative",
            top: "-3.5px",
            left: "1.5px",
            // width: "100%",
            // height: "100%",
            // borderRadius: "2px",
            // backgroundColor: Color.primary,
            // border: "1px solid #000",
          }}>
          ✔
        </Box>
      )}
    </Box>
  );
};

export default FettiCheckbox;
